import { Inject, Injectable } from '@angular/core';
import { BaseEndpoint } from '../app.constants';
import { Http } from '@angular/http';
import { AdalService } from '../shared/azure-authentication/adal.service';
import { ReassignmentDto, ReassignmentBaseDto, ReassignmentResponse, IgnoredProcessorCloserReassignment } from './reassignment';
import { PipelineLoanDto, Reshuffle, ReshuffleResponse } from '../uw-assignment-reshuffle/reshuffle';
import { User } from '../users/user.model';

@Injectable()
export class ProcessorCloserReassignmentService {

    constructor(private http: Http, @Inject(BaseEndpoint) private baseApiUrl: string, private adalService: AdalService) {
    }

    async getProcessorPendingLoans(): Promise<any> {
        const url = this.baseApiUrl + 'v1/reassignment/processor';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                return resp.json().body;
            })
            .catch(this.handleError);
    }

    async getCloserPendingLoans(): Promise<any> {
        const url = this.baseApiUrl + 'v1/reassignment/closer';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                return resp.json().body;
            })
            .catch(this.handleError);
    }

    async makePendingCloserReassignment(reassignment: ReassignmentDto): Promise<ReassignmentResponse> {
        const url = this.baseApiUrl + 'v1/reassign/pendingcloser';
        return this.http
            .post(url, reassignment, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                return resp.json();
            })
            .catch(this.handleError);
    }

    async makePendingProcessorReassignment(reassignment: ReassignmentDto): Promise<ReassignmentResponse> {
        const url = this.baseApiUrl + 'v1/reassign/pendingprocessor';
        return this.http
            .post(url, JSON.stringify(reassignment), { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                return resp.json();
            })
            .catch(this.handleError);
    }

    deletePendingLoan(ignoredProcessorCloserReassignment: IgnoredProcessorCloserReassignment): Promise<boolean> {
        const url = this.baseApiUrl + 'v1/deletependingloan';
        return this.http
            .put(url, JSON.stringify(ignoredProcessorCloserReassignment), { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var success = !resp.json().hasErrors as boolean;
                return success;
            })
            .catch(this.handleError);
    }

    getHistoricalCloserUsers(): Promise<any> {
        const url = this.baseApiUrl + 'v1/reassignment/closerUsers';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                return resp.json().body;
            })
            .catch(this.handleError);
    }

    getHistoricalProcessorUsers(): Promise<User[]> {
        const url = this.baseApiUrl + 'v1/reassignment/processorUsers';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                return resp.json().body as User[];
            })
            .catch(this.handleError);
    }

    private handleError(errors: string[]): Promise<any> {
        console.error('An error occurred', errors);
        return Promise.reject(errors);
    }

   public async getLoansbyUserAndPersona(user:User,persona:string): Promise<any> {
        const url = this.baseApiUrl + 'v1/reassignment/getLoansbyUserAndPersona';
       var userId = user.id;
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader(), params: { persona: persona, userId: userId } })
            .toPromise()
            .then(resp => {
                return resp.json().body;
            })
            .catch(this.handleError);
    }

    public async getCollectionOfLoansbyUserAndPersona(user: User, persona: string): Promise<any> {
        const url = this.baseApiUrl + 'v1/reassignment/getCollectionOfLoansbyUserAndPersona';
        var userId = user.id;
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader(), params: { persona: persona, userId: userId } })
            .toPromise()
            .then(resp => {
                return resp.json().body;
            })
            .catch(this.handleError);
    }

    makeProcessorReassignment(reassignment: ReassignmentBaseDto): Promise<ReshuffleResponse> {
        const url = this.baseApiUrl + 'v1/reassignment/processor';
        return this.http
            .post(url, JSON.stringify(reassignment), { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                return resp.json();
            })
            .catch(this.handleError);
    }

    async makeCloserReassignment(reassignment: ReassignmentBaseDto): Promise<ReshuffleResponse> {
        const url = this.baseApiUrl + 'v1/reassignment/closer';
        return this.http
            .post(url, JSON.stringify(reassignment), { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                return resp.json();
            })
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/processor-closer-pipeline-reassignment/processor-closer-reassignment.service.ts